import { InformationmarkSmallCircleIcon } from '@zep/icons';
export const PlanNotiText = (props: {
  alertText: string;
}) => {
  return <div className="flex items-center gap-[4px]" data-sentry-component="PlanNotiText" data-sentry-source-file="PlanNotiText.tsx">
      <span>
        <InformationmarkSmallCircleIcon width={14} height={14} fill={'#27262EA3'} data-sentry-element="InformationmarkSmallCircleIcon" data-sentry-source-file="PlanNotiText.tsx" />
      </span>
      <span className="text-caption-1 font-[600] text-[#27262EA3]">
        {props.alertText}
      </span>
    </div>;
};